import { ListTableColumn, createListTableColumns, renderBooleanIcon } from "sprint-common-web";

import { renderBuzzVersionItem } from "../../../../common/components/BuzzVersionItem";
import { renderContentVersionSource } from "../../../../common/utils/renderContentVersionSource";
import { AddEpisodeVersionToMergeListButton } from "./buttons/AddEpisodeVersionToMergeListButton";
import { EditEpisodeVersionButton } from "./buttons/EditEpisodeVersionButton";
import { ViewEpisodeVersionAssetButton } from "./buttons/ViewEpisodeVersionAssetButton";
import { EpisodeVersionListingItem } from "./EpisodeVersionListingItem";

export const createEpisodeVersionListingColumns = (): ListTableColumn<EpisodeVersionListingItem>[] => {
    return createListTableColumns<EpisodeVersionListingItem>([
        {
            type: "basic",
            key: "distributorName",
            name: "Distributor",
            minWidth: 50,
            maxWidth: 330,
            isSortable: true
        },
        {
            type: "basic",
            key: "typeName",
            name: "Type",
            minWidth: 65,
            maxWidth: 330,
            isSortable: true
        },
        {
            type: "basic",
            key: "code",
            name: "Code",
            minWidth: 85,
            maxWidth: 350
        },
        {
            type: "basic",
            key: "brandings",
            name: "Brandings",
            minWidth: 70,
            maxWidth: 280,
            isSortable: false,
            isMultiline: true
        },
        {
            type: "basic",
            key: "source",
            name: "Source",
            minWidth: 65,
            maxWidth: 90,
            isSortable: false,
            onRender: renderContentVersionSource
        },
        {
            type: "basic",
            key: "buzzVersion",
            name: "Version details",
            minWidth: 120,
            maxWidth: 400,
            isSortable: false,
            onRender: (item) => {
                return renderBuzzVersionItem(item?.buzzVersion);
            }
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 50,
            maxWidth: 50,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 96,
            maxWidth: 96,
            buttons: [
                {
                    id: "edit",
                    render: EditEpisodeVersionButton
                },
                {
                    id: "viewAssets",
                    render: ViewEpisodeVersionAssetButton
                },
                {
                    id: "AddEpisodeVersionToMergeList",
                    render: AddEpisodeVersionToMergeListButton
                }
            ]
        }
    ]);
};
